import { createAction } from 'redux-act';

export const register = createAction();
export const receivedSignUp = createAction();

export const checkClubByCode=createAction();
export const receivedCheckClubByCode = createAction();

export const cleanCheckClubByCode=createAction();
